/**
 * 
 * @param v1 版本号1
 * @param v2 版本号2
 * v1 > v2 返回1
 * v1 < v2 返回-1
 * v1 === v2 返回0
 * @returns 
 */

export const compareVersion = (v1, v2) => {
    if(!v1){
        v1 = "0.0.0"
    }
    if (v1 == v2) {
        return 0;
    }

    const vs1 = v1.split(".").map(a => parseInt(a));
    const vs2 = v2.split(".").map(a => parseInt(a));

    const length = Math.min(vs1.length, vs2.length);
    for (let i = 0; i < length; i++) {
        if (vs1[i] > vs2[i]) {
            return 1;
        } else if (vs1[i] < vs2[i]) {
            return -1;
        }
    }

    if (length == vs1.length) {
        return -1;
    } else {
        return 1;
    }
}